import type { ThemeOverride } from '@chakra-ui/react';

export const zIndices: ThemeOverride['zIndices'] = {
   header: 2000,
   headerNavigation: 2000,
};
